import type { Picture } from '../gql';

import { randBoolean, randNumber, randUrl, randWord } from '@ngneat/falso';

const mockStylePicture = (override?: Partial<Picture>): Picture => ({
    url: randUrl(),
    perspectiveNumber: randNumber({ min: 1, max: 5 }),
    perspectiveName: randWord(),
    isThumbnail: randBoolean(),
    ...override,
    ['__typename']: 'Picture', // Needed for apollo mocking
});

// Helper to create multiple pictures
const mockStylePictures = (options?: {
    overrideAll?: Partial<Picture>;
    overrideIndividual?: Array<Partial<Picture>>;
    min?: number;
    max?: number;
}): Array<Picture> => {
    const min = options?.min ?? 1;
    const max = options?.max ?? 5;

    // Ensure the length always includes overrides
    const randLength = randNumber({ min, max });
    const overridesLength = options?.overrideIndividual?.length ?? 0;
    const length =
        overridesLength > randLength
            ? overridesLength
            : randNumber({ min, max });

    return Array.from({ length }, (_, i) => {
        // Ensure all overrides are used, and can be combined
        const override = {
            ...options?.overrideAll,
            ...options?.overrideIndividual?.[i],
        };
        return mockStylePicture(override);
    });
};

export { mockStylePicture, mockStylePictures };
